export default "__VITE_ASSET__0c1d452b__"